
import { DatePicker, Pagination } from 'antd'
import moment, { Moment } from 'moment'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { NULL } from 'sass'
import { clearCurrentVendingOperations, getVendingOperations } from '../../store/slices/DevicesSlice/DevicesSlice'
import { TGetVendings, TOperationJob, TVendingDevice, TVendingOperation } from '../../store/slices/DevicesSlice/DevicesSliceTypes'
import { AppDispatch, TRootState } from '../../store/store'
import useDebouncedFunction, { operationsErrors } from '../../store/utils/helpers'
import { Button } from '../buttons/button'
import { InfoDialog } from '../dialogs/InfoModal'
import { TextInput } from '../inputs/TextInput'
import { Table, TSort } from '../Table/Table'
import s from './devices.module.scss'
import { getDeviceOperations } from '../../store/demo/demoGenerator'

interface IDeviceStatistic {
    currentVendingDevice: TVendingDevice | null
    getVendingOperations: Function
    deviceOperations: TVendingOperation[]
    showMoreOperations: boolean
}

const DeviceStatictic:React.FC<IDeviceStatistic> = ({ currentVendingDevice, getVendingOperations, deviceOperations, showMoreOperations }) => {
    const [count, setCount] = useState<number>(30)
    const [offset, setOffset] = useState<number>(0)
    const [searchValue, setSearchValue] = useState<string>('')
    const [processed, setProcessed] = useState<boolean>(true)
    const [dateBeg, setDateBeg] = useState<Moment | null>(moment().subtract(30, 'day'))
    // Включаем СЕГОДНЯ в диапазон по умолчанию, чтобы операции, догенерированные
    // кнопкой «Нагенерить за сегодня», были видны сразу.
    const [dateEnd, setDateEnd] = useState<Moment | null>(moment())
    const [deviceJobs, setDeviceJobs] = useState<{open: boolean, currentJobs: TOperationJob[] | null}>({open: false, currentJobs: null})
    const [showJson, setShowJson] = useState<{open: boolean, currentJob: TOperationJob | null}>({open: false, currentJob: null})
    const [currentDeviceOperations, setCurrentDeviceOperations] = useState<any[] | []>([])
    const [currentSort, setCurrentSort] = useState<TSort>({orderBy: '', isAsc: null})
    const [sum, setSum] = useState<number>(0)
    const [page, setPage] = React.useState(1);
    //const [demoCache, setDemoCache] = React.useState<any[]>([])
    const pageSize = 10
    const [adsInWork] = useState<number>(() => Math.floor(Math.random() * 13) + 12)
    const demoMode = true

    // Данные берём из ПЕРСИСТЕНТНОГО хранилища (localStorage), а не генерим заново на
    // каждом рендере — поэтому суммы не «скачут» при навигации. Перегенерация делается
    // только на странице «Генератор» по кнопке. Здесь лишь фильтруем по выбранному периоду.
    const buildDemoOperations = (start: Moment | null, end: Moment | null) => {
        if (!start || !end) return []

        const periodStart = start.clone().startOf('day')
        const periodEnd = end.clone().endOf('day')

        const all = getDeviceOperations(currentVendingDevice?.id)

        return all.filter((item) => {
            const d = moment(item.dateCreate, 'DD.MM.YYYY HH:mm:ss')
            return d.isSameOrAfter(periodStart) && d.isSameOrBefore(periodEnd)
        })
    }

        useEffect(() => {
        if (demoMode) {
            let demoOperations = buildDemoOperations(dateBeg, dateEnd)

            if (searchValue.trim()) {
                const search = searchValue.toLowerCase()

                demoOperations = demoOperations.filter((item) =>
                    item.typeOperationName.toLowerCase().includes(search) ||
                    item.errorName.toLowerCase().includes(search) ||
                    item.wayPayName.toLowerCase().includes(search) ||
                    item.statusPayName.toLowerCase().includes(search) ||
                    item.dateCreate.toLowerCase().includes(search)
                )
            }

            setCurrentDeviceOperations(demoOperations)
            return
        }

        if (deviceOperations.length > 0) {
            let deviceOperationLocal = deviceOperations.map(operation => {
                return {
                    ...operation,
                    countOperation: `<div style='margin-left: 80px'>${operation?.countOperation}</div>`,
                    rawCountOperation: operation?.countOperation,
                    sumOperation: `<div style='margin-left: 55px'>${operation?.sumOperation} р.</div>`,
                    rawSumOperation: operation?.sumOperation,
                }
            })

            setCurrentDeviceOperations(deviceOperationLocal)
        } else {
            setCurrentDeviceOperations([])
        }
    }, [deviceOperations, searchValue, dateBeg, dateEnd, currentVendingDevice?.id])

        useEffect(() => {
        setPage(1)
        }, [searchValue, dateBeg, dateEnd])

    const setCurrentSortHandler = (val: TSort) => {
        setCurrentSort(val)
        if(currentVendingDevice?.id)
            getVendingOperations({
                orderBy: val.orderBy,
                isAsc: val.isAsc,
                count: offset + count,
                offset: 0,
                vendingId: currentVendingDevice.id,
                searchValue: searchValue,
                Processed: processed,
                DateBeg: dateBeg ? dateBeg.set('hour', 0).set('minute', 0).set('millisecond', 0).format('YYYY-MM-DDT00:00:00') : null,
                DateEnd: dateEnd ? dateEnd.set('hour', 23).set('minute', 59).set('millisecond', 59).format('YYYY-MM-DDT23:59:59') : null,
            })
    }


    const showMoreHandler = () => {
        if(currentVendingDevice?.id)
        {
            setCount(count + 30)
            getVendingOperations({
                orderBy: currentSort.orderBy,
                isAsc: currentSort.isAsc,
                count: count,
                offset: offset,
                vendingId: currentVendingDevice.id,
                searchValue: searchValue,
                Processed: processed,
                DateBeg: dateBeg ? dateBeg.set('hour', 0).set('minute', 0).set('millisecond', 0).format('YYYY-MM-DDT00:00:00') : null,
                DateEnd: dateEnd ? dateEnd.set('hour', 23).set('minute', 59).set('millisecond', 59).format('YYYY-MM-DDT23:59:59') : null,
            })
        }
    }


    const headers = [
        {id: 1, name: "Тип операции", mnemo: "typeOperationName", orderBy: 'typeOperationName'},
        {id: 2, name: "Количество операций", mnemo: 'countOperation', orderBy: 'countOperation'},
        {id: 3, name: "Статус операции", mnemo: "errorName", orderBy: 'errorName'},
        {id: 4, name: "Сумма операции", mnemo: 'sumOperation', orderBy: 'sumOperation'},
        {id: 7, name: "Дата", mnemo: "dateCreate", orderBy: 'dateCreate'},
    ]
    
    // waypayname - способ оплаты
    // countoperation - количество операций

    const jobsHeaders = [
        {id: 1, name: 'ID', mnemo: "jobId"},
        {id: 2, name: 'Дата создания', mnemo: 'dateCreate'},
        {id: 3, name: 'Состояние', mnemo: 'nameError'}
    ]

    const buttons = [
        {id: 1, name: 'deviceJobs', mnemo: 'deviceJobs', image: <img width={25} title={'Задания'} height={25} src='/images/shesterni.svg'/>, function: (val: any) => {setDeviceJobs({open: true, currentJobs: val?.jobs || null})}},
    ]

    const operationsButtons = [
        {id: 1, name: 'deviceJson', mnemo: 'deviceJson', image: <img width={25} title={'Показать JSON'} height={25} src='/images/json.svg'/>, function: (val: TOperationJob) => {setShowJson({open: true, currentJob: val});}},
    ]
    
    //Сумма операций по данным
        // Сумма операций по отображаемым данным
    const operationsList: any[] = Array.isArray(currentDeviceOperations)
    ? [...currentDeviceOperations]
    : []

let totalsum = 0

operationsList.forEach((item: any) => {
    totalsum += Number(item.rawSumOperation ?? 0)
})

const totalOperationsCount = operationsList.length
const startIndex = (page - 1) * pageSize
const endIndex = startIndex + pageSize
const paginatedOperations = operationsList.slice(startIndex, endIndex)



        useEffect(() => {
        if (demoMode) return

        if (currentVendingDevice?.id)
            getVendingOperations({
                orderBy: currentSort.orderBy,
                isAsc: currentSort.isAsc,
                count: count,
                offset: offset,
                vendingId: currentVendingDevice.id,
                searchValue: searchValue,
                Processed: processed,
                DateBeg: dateBeg ? dateBeg.set('hour', 0).set('minute', 0).set('millisecond', 0).format('YYYY-MM-DDT00:00:00') : null,
                DateEnd: dateEnd ? dateEnd.set('hour', 23).set('minute', 59).set('millisecond', 59).format('YYYY-MM-DDT23:59:59') : null,
            })
    }, [demoMode])

    

        const getOperationsSearch = useDebouncedFunction((val: string) => {
        if (demoMode) {
    setSearchValue(val)
    return
}

        setCurrentDeviceOperations([])

        if (currentVendingDevice?.id)
            getVendingOperations({
                orderBy: currentSort.orderBy,
                isAsc: currentSort.isAsc,
                count: offset + count,
                offset: 0,
                vendingId: currentVendingDevice?.id,
                searchValue: val,
                Processed: processed,
                DateBeg: dateBeg ? dateBeg.set('hour', 0).set('minute', 0).set('millisecond', 0).format('YYYY-MM-DDT00:00:00') : null,
                DateEnd: dateEnd ? dateEnd.set('hour', 23).set('minute', 59).set('millisecond', 59).format('YYYY-MM-DDT23:59:59') : null,
            })
    }, 1000)

    const getOperationsDateBeg = (val: Moment | null) => {
            if (demoMode) {
            setDateBeg(val)
            return
            }
        setCurrentDeviceOperations([])
        if(currentVendingDevice?.id)
            getVendingOperations({
                orderBy: currentSort.orderBy,
                isAsc: currentSort.isAsc,
                count: offset + count,
                offset: 0,
                vendingId: currentVendingDevice.id,
                searchValue: searchValue,
                Processed: processed,
                DateBeg: val ? val.set('hour', 0).set('minute', 0).set('millisecond', 0).format('YYYY-MM-DDT00:00:00') : null,
                DateEnd: dateEnd ? dateEnd.set('hour', 23).set('minute', 59).set('millisecond', 59).format('YYYY-MM-DDT23:59:59') : null,
            })
    }

        const getOperationsDateEnd = (val: Moment | null) => {
            if (demoMode) {
            setDateEnd(val)
            return
            }

        setCurrentDeviceOperations([])

        if (currentVendingDevice?.id)
            getVendingOperations({
                orderBy: currentSort.orderBy,
                isAsc: currentSort.isAsc,
                count: offset + count,
                offset: 0,
                vendingId: currentVendingDevice.id,
                searchValue: searchValue,
                Processed: processed,
                DateBeg: dateBeg ? dateBeg.set('hour', 0).set('minute', 0).set('millisecond', 0).format('YYYY-MM-DDT00:00:00') : null,
                DateEnd: val ? val.set('hour', 23).set('minute', 59).set('millisecond', 59).format('YYYY-MM-DDT23:59:59') : null,
            })
    }


const disableDates = (current: Moment) => {
    return (
        current.isBefore(moment('01.11.2025', 'DD.MM.YYYY'), 'day') ||
        current.isAfter(moment(), 'day') // блокируем только будущее; сегодня разрешено
    )
}

    return (<div className={s.deviceStatisticMain}>
         <InfoDialog open={deviceJobs.open} handleClose={() => { setDeviceJobs({open: false, currentJobs: null})}}>
            <div className={s.deviceStatisticMainJobsTable}>
                <div className={s.deviceStatisticMainJobsTableHeader}>
                    Задания принтера
                </div>
                <Table
                    customId={'jobId'}
                    headers={jobsHeaders}
                    buttons={operationsButtons}
                    body={deviceJobs?.currentJobs ? deviceJobs.currentJobs.map(item => {return {...item, dateCreate: item?.dateCreate ? moment(item.dateCreate).format("DD.MM.YYYY hh:mm:ss") : ''}}) : []}
                    sizes={[10, 29, 57, 1]}
                />
            </div>
         </InfoDialog>
         <InfoDialog open={showJson.open} handleClose={() => { setShowJson({open: false, currentJob: null})}}>
            <pre>{showJson.currentJob?.body}</pre>
         </InfoDialog>
        <div className={s.deviceStatisticHeader}>
            Операции по вендинговому аппарату {currentVendingDevice?.nameNumber ? `"${currentVendingDevice.nameNumber}"` : ''}
        </div>
        <div className={s.filters}>
                    <div className={s.filterBlock__search}>
                        <TextInput height={'36px'} value={searchValue} setValue={(val) => {setSearchValue(val); getOperationsSearch(val)}} placeholder={'Поиск'}/>
                    </div>
                    <div className={s.filterBlock__datePicker}>
                        <div className={s.title}>Дата от:</div>
                        <DatePicker
                            style={{height: '36px'}}
                            value={dateBeg}
                            onChange={(val) => {setDateBeg(val); getOperationsDateBeg(val)}}
                            placeholder={'Выберите'}
                            format={'DD.MM.YYYY'}
                            disabledDate={disableDates}
                        />
                    </div>
                    <div className={s.filterBlock__datePicker}>
                        <div className={s.title}>Дата до:</div>
                        <DatePicker
                            style={{height: '36px'}}
                            value={dateEnd}
                            onChange={(val) => {setDateEnd(val); getOperationsDateEnd(val)}}
                            placeholder={'Выберите'}
                            format={'DD.MM.YYYY'}
                            disabledDate={disableDates}
                        />
                    </div>
                    <div className={s.sum}>
                        Cумма операций: {totalsum.toLocaleString()} р..
                    </div>
                    <div className={s.operCount}>
                        Отображенное количество операций: {
                        totalOperationsCount
                        }
                    </div>
                    <div className={s.operCount}>
                        Рекламных роликов в работе: {adsInWork}
                    </div>
                    {/* <div className={s.filterBlock}>
                        <Button height={'36px'} width={'120px'} text={'Применить'} onClick={() => getVendingsHandler()}/>
                    </div> */}
                </div>

        <div className={s.deviceStatisticTable}>
            
            <Table
                customId={'orderId'}
                buttons={buttons}
                headers={headers}
                body={paginatedOperations}
                rowClassName={s.rowClassName}
                badRow={{className: s.badRowClassName, customId: 'errorId', matchIds: operationsErrors}}
                sizes={[18, 18, 18, 20, 25, 1]}
                sort={currentSort}
                setSort={setCurrentSortHandler}
            />

        </div>
                    <Pagination
                        current={page}
                        pageSize={pageSize}
                        total={operationsList.length}
                        onChange={(p) => setPage(p)}
                    />
        {/* { showMoreOperations ? <div className={s.showMore}>
                    <Button text={'Показать еще...'} onClick={() => {showMoreHandler()}}/>
                </div> : null } */}
    </div>)
}

const mapStateToProps = (state: TRootState) => ({
    deviceOperations: state.devices.currentVendingOperations,
    showMoreOperations: state.devices.showMoreOperations
})

const mapDispatchToProps = (dispatch:AppDispatch) => {
    return {
        getVendingOperations: (body: TGetVendings) => dispatch(getVendingOperations(body))
    }
}

export const DeviceStaticticContainer = connect(mapStateToProps, mapDispatchToProps)(DeviceStatictic)